import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SolutionTask from "./SolutionTask";
import GridConfig from "../GridConfig";
import TaskStepsReport from "./TaskStepsReport";

export default class SolutionTasks extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            solutionId: props.SolutionId,
            controllerName: 'solution/task',
            data: null,
            loading: true,
            configName: 'solution_task_grid',
            moduleName: 'وظایف'
        };
        this.state.filters = {
            solutionId: this.state.solutionId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <SolutionTask Caller={this} Id={id} SolutionId={this.state.solutionId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <SolutionTask Caller={this} SolutionId={this.state.solutionId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "workFlowName", caption: "گردش کاری", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 3, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'workFlowName' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a onClick={e => this.ShowTaskStepReports(props.data.id)} className="hand text-success">
                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> گزارش مراحل</span>
                    </a>
                ]
            }
        });
        return t;
    }
    ShowTaskStepReports(taskId) {
        this.removeKeyDown();
        this.showComponents({ component: <TaskStepsReport Caller={this} TaskId={taskId} /> });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">وظایف</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: true, pdf: true, excell: true, remove: true, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}